import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "react-bootstrap";
import "./Main.css";
import "./Home.css";
import TopNav from "./TopNav";
import MainNav from "./MainNav";
import LoginCheck from "../util/LoginCheck";
import DecodeData from "../util/DecodeData";
import LoginFail from "../util/LoginFail";
import HomeCard from "../util/HomeCard";
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectCenter from "../util/SelectCenter";
import Moment from "react-moment";
import { subDays } from "date-fns";
import { format } from "date-fns";
import ko from "date-fns/locale/ko";
import pr from "../lib/pr.js";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import { loginState, configState } from "../lib/State";
import Layout from "./Layout";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import CenterSelect from "./CenterSelect";
import { Box } from "@mui/material";
import BillboardChart from "react-billboardjs";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";


const CHART_DATA = {
  x: "x",
  columns: [],
  type: "spline",
  // types: {
  //   data2: "bar",
  // },
  names: {},
};

const axis = {
  x: {
    type: "timeseries",
    tick: {
      count: 7,
      format: "%m.%d"
    }
  }
}

export default function ChartClass() {

  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [tcid, setTcid] = useState('');
  const [rows, setRows] = useState(CHART_DATA);
  const token = get_token();
  const cid = get_cid();
  const [data, setData] = useState([]);

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);


  const get_data = async () => {
    let tmp,i;    

    let result = await axios.post(configState.api + '/chart/class_daily', {
      token: token,
      cid: cid,
      tcid: tcid,
    });
    console.log(result.data.columns);

    if (result.data.success !== 1) {
      Swal.fire('오류', result.data.msg);
      return;
    }

    setRows({
      x: "x",
      columns: result.data.columns,
      type: "spline",
      names: result.data.names,
    });

    // total DATA
    // setData([
    //   {id:'1', name:'09:00' , count:0},
    //   {id:'2', name:'10:00' , count:0},
    //   {id:'3', name:'11:00' , count:0},
    //   {id:'4', name:'12:00' , count:0}
    // ]);
    setData(result.data.total);

  }

  useEffect(() => {
    get_data();
  }, [tcid]);


  // 합계
  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "hour", headerName: "수업시간", width: 130, align: "center" },
    { field: "count", headerName: "수업인원", width: 130, align: "center" },
  ];

  return (
    <Layout login={login}>
      <div>

        <Box sx={{ mt: 1 }}>
          <CenterSelect
            login={login}
            tcidParent={tcid}
            setTcidParent={setTcid}
          />
        </Box>

        <Box marginTop={1} display="flex">
          <Box marginRight={1}>
            <Button onClick={() => window.location.href = '/chart_class'}>일간보기</Button>
          </Box>
          <Box marginRight={1}>
            <Button onClick={() => window.location.href = '/chart_class_weekly'}>주간보기</Button>
          </Box>
          <Box marginRight={1}>
            <Button onClick={() => window.location.href = '/chart_class'}>월간보기</Button>
          </Box>
        </Box>

        <Box fontWeight="bold" fontSize={16} marginTop={3}>
          일간 수업별 예약현황
        </Box>

        <Box marginTop={3} width={900}>
          <BillboardChart data={rows} axis={axis} />
        </Box>

        <Box width={900} height={350} marginTop={5} fontSize={12}>
          <DataGrid            
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onRowClick={(params) => {
            }}
          />
        </Box>

      </div>
    </Layout>
  );
}